import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {ApiResponseGetLastOdometerResponse} from '@di-shared/api/di/__generated';
import {parseDateWithFormat} from '@shared/dateUtils';
import environmentStore from '@di-shared/features/environment/environmentStore';

function useOdometer(vin: string) {
  const ccid = environmentStore.getState().ccid;
  const {
    data: {value: odometer, updatedAt},
    refetch,
  } = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.maintenancesSestController.getLastOdometer1), vin, ccid],
    queryFn: () =>
      diApi.maintenancesSestController.getLastOdometer1({
        vin,
        ccid,
      }),
    select: (data: ApiResponseGetLastOdometerResponse) => data.data,
  });
  return {odometer, updatedDate: parseDateWithFormat(updatedAt), refetch};
}

export default useOdometer;
